import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Option, OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {Observable, Subscriber} from 'rxjs';
import {ConnectedPosition} from '@angular/cdk/overlay';

@Component({
    template: '',
    styleUrls: ['./popover-multi-select-object-base.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class PopoverMultiSelectObjectBaseComponent implements OnInit {
  @Output() ready$: EventEmitter<OptionGroupMultiSelect> = new EventEmitter<OptionGroupMultiSelect>();
  @Output() clickedOption$: EventEmitter<Option> = new EventEmitter<Option>();
  @Output() clickedOutsideMenu$: EventEmitter<null> = new EventEmitter();

  /**
   * Optional to provide as @Input. Will otherwise be filled in automatically.
   */
  @Input() optionGroup: OptionGroupMultiSelect;
  @Input() multiOrSingle: 'multi' | 'single' = 'multi';
  @Input() overlayPositions: ConnectedPosition[] = [{
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
  }];

  optionGroup$: Observable<OptionGroupMultiSelect>;


  protected constructor() {
  }


  ngOnInit(): void {
    this.onInit();
  }


  protected abstract onInit();


  protected abstract prepareOptionGroup(): OptionGroupMultiSelect;


  protected optionGroupIsPrepared(): boolean {
    return !!this.optionGroup;
  }


  /**
   * Each onInit is expected to set this.optionGroup$ to a new Observable, and
   * the `subscriber` variable in the callback passed to new Observable() should
   * be passed here to then be uniformly emitted for each class extending this
   * one.
   *
   * This was created because the body of this method was being repeated in MANY
   * places, even within a single Component class.
   *
   * What gets emitted is the fully assembled OptionGroup instance that will be
   * used by the menu. An exact reference to the object is emitted.
   *
   * This does not cover the error use case for the observable.
   *
   * @param subscriber
   * @protected
   */
  protected initSubscriberHandle(subscriber: Subscriber<OptionGroupMultiSelect>) {
    subscriber.next(this.optionGroup);
    subscriber.complete();
    this.ready$.emit(this.optionGroup);
  };
}
